<p-select
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  (onBlur)="onBlur()"
  [options]="countriesWithLabels()"
  optionValue="isoCode"
  optionLabel="searchLabel"
  [placeholder]="placeholder()"
  [disabled]="disabled"
  [filter]="true"
  filterBy="searchLabel"
  class="w-full"
  [attr.data-testid]="testId()"
  [ngClass]="{
    'ng-invalid ng-dirty': ngControl?.control?.invalid && ngControl?.control?.touched,
  }"
>
  <ng-template #item let-country>
    <div class="flex items-center">
      <span class="fi fi-{{ country.isoCode | lowercase }} mr-2"></span>
      {{ country.searchLabel }}
    </div>
  </ng-template>
  <ng-template #selectedItem let-country>
    <div class="flex items-center">
      <span class="fi fi-{{ country.isoCode | lowercase }} mr-2"></span>
      {{ country.searchLabel }}
    </div>
  </ng-template>
</p-select>
